export default "__VITE_ASSET__9QtV6$R2__"